import { logout } from '@/api/api.auth';
import { FC, ReactNode } from 'react';
import { useFetcher } from 'react-router-dom';
import { toast } from 'react-toastify';

export const logoutAction = (resetAuth: () => void) => {
  try {
    logout();
    resetAuth();
    toast.success('Logged out successfully', {
      autoClose: 1000,
    });
  } catch (error) {
    toast.error('Logout failed. Please try again.');
    console.error('Logout failed:', error);
  }
};

interface HandleLogoutWrapperProps {
  children: ReactNode;
}
export const HandleLogoutWrapper: FC<HandleLogoutWrapperProps> = ({ children }) => {
  const fetcher = useFetcher();

  return (
    <fetcher.Form method="post" action="/logout">
      {children}
    </fetcher.Form>
  );
};
